(function () {
  'use strict';

  /** Cloud Run チャット API（スニペット data-api-url またはここで上書き） */
  const DEFAULT_CHAT_API_ENDPOINT = 'https://ai-chat-backend-6ecbv7npqa-uc.a.run.app/chat';
  // バックエンドのタイムアウト（既定35秒）より後ろに置く。同値だとクライアントが
  // 先に abort してしまい、バックエンドが返す日本語のフォールバック文言が届かない。
  // Gemini 3.7 Flash は思考モデルで、複雑な質問では応答に10秒以上かかる。
  const REQUEST_TIMEOUT_MS = 40000;
  const FALLBACK_MESSAGE =
    '現在チャットが利用できません。検索窓をご利用ください。';

  const root = document.getElementById('tc-ai-chat-root');
  if (!root) return;

  const apiUrl = root.dataset.apiUrl || DEFAULT_CHAT_API_ENDPOINT;
  const toggleBtn = document.getElementById('tc-ai-chat-toggle');
  const panel = document.getElementById('tc-ai-chat-panel');
  const closeBtn = document.getElementById('tc-ai-chat-close');
  const expandBtn = document.getElementById('tc-ai-chat-expand');
  const resizeHandle = document.getElementById('tc-ai-chat-resize-handle');
  const messagesEl = document.getElementById('tc-ai-chat-messages');
  const form = document.getElementById('tc-ai-chat-form');
  const input = document.getElementById('tc-ai-chat-input');
  const sendBtn = document.getElementById('tc-ai-chat-send');

  /** @type {{role: 'user'|'assistant', content: string}[]} */
  const history = [];
  let isOpen = false;
  let isLoading = false;
  let lastFocusedElement = null;

  function formatPrice(price, currency) {
    if (price == null || Number.isNaN(Number(price))) return '';
    try {
      return new Intl.NumberFormat('ja-JP', {
        style: 'currency',
        currency: currency || 'JPY',
        maximumFractionDigits: 0,
      }).format(Number(price));
    } catch {
      return `${price} ${currency || 'JPY'}`;
    }
  }

  function setPanelOpen(open) {
    isOpen = open;
    panel.hidden = !open;
    toggleBtn.setAttribute('aria-expanded', String(open));

    if (open) {
      lastFocusedElement = document.activeElement;
      input.focus();
    } else if (lastFocusedElement && lastFocusedElement.focus) {
      lastFocusedElement.focus();
    }
  }

  function appendBubble(text, role) {
    const bubble = document.createElement('div');
    bubble.className = `tc-ai-chat__bubble tc-ai-chat__bubble--${role}`;
    bubble.textContent = text;
    messagesEl.appendChild(bubble);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return bubble;
  }

  function appendError(text) {
    const bubble = document.createElement('div');
    bubble.className = 'tc-ai-chat__bubble tc-ai-chat__bubble--error';
    bubble.setAttribute('role', 'alert');
    bubble.textContent = text;
    messagesEl.appendChild(bubble);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function appendProducts(products) {
    if (!Array.isArray(products) || products.length === 0) return;

    const wrap = document.createElement('div');
    wrap.className = 'tc-ai-chat__products';
    wrap.setAttribute('aria-label', 'おすすめ商品');

    products.forEach((product) => {
      const card = document.createElement('article');
      card.className = 'tc-ai-chat__product-card';

      if (product.imageUrl) {
        const img = document.createElement('img');
        img.className = 'tc-ai-chat__product-image';
        img.src = product.imageUrl;
        img.alt = product.title || '商品画像';
        img.loading = 'lazy';
        card.appendChild(img);
      } else {
        const placeholder = document.createElement('div');
        placeholder.className = 'tc-ai-chat__product-image';
        placeholder.setAttribute('aria-hidden', 'true');
        card.appendChild(placeholder);
      }

      const body = document.createElement('div');
      const title = document.createElement('h3');
      title.className = 'tc-ai-chat__product-title';
      title.textContent = product.title || '商品';

      const price = document.createElement('p');
      price.className = 'tc-ai-chat__product-price';
      price.textContent = formatPrice(product.price, product.currency);

      // CTAは常にShopify内の商品ページへリンクする（外部モールへは送客しない）
      const link = document.createElement('a');
      link.className = 'tc-ai-chat__product-link';
      link.href = product.ctaHref || product.productUrl || '#';
      link.textContent = product.ctaLabel || '商品を見る';
      link.target = product.ctaTarget || '_self';
      if (link.target === '_blank') {
        link.rel = 'noopener noreferrer';
      }

      body.appendChild(title);
      body.appendChild(price);
      body.appendChild(link);
      card.appendChild(body);
      wrap.appendChild(card);
    });

    messagesEl.appendChild(wrap);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function appendArticles(articles) {
    if (!Array.isArray(articles) || articles.length === 0) return;

    const wrap = document.createElement('div');
    wrap.className = 'tc-ai-chat__articles';
    wrap.setAttribute('aria-label', '関連記事');

    articles.forEach((article) => {
      const card = document.createElement('article');
      card.className = 'tc-ai-chat__article-card';

      const body = document.createElement('div');

      const title = document.createElement('h3');
      title.className = 'tc-ai-chat__article-title';
      title.textContent = article.title || '記事';

      const summary = document.createElement('p');
      summary.className = 'tc-ai-chat__article-summary';
      summary.textContent = (article.summary || '').slice(0, 90);

      const link = document.createElement('a');
      link.className = 'tc-ai-chat__article-link';
      link.href = article.ctaHref || article.articleUrl || '#';
      link.textContent = article.ctaLabel || '記事を読む';
      link.target = article.ctaTarget || '_self';
      if (link.target === '_blank') {
        link.rel = 'noopener noreferrer';
      }

      body.appendChild(title);
      if (summary.textContent) body.appendChild(summary);
      body.appendChild(link);
      card.appendChild(body);
      wrap.appendChild(card);
    });

    messagesEl.appendChild(wrap);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function setLoading(loading) {
    isLoading = loading;
    sendBtn.disabled = loading;
    input.disabled = loading;
  }

  async function sendMessage(message) {
    appendBubble(message, 'user');
    history.push({ role: 'user', content: message });

    const typing = document.createElement('div');
    typing.className = 'tc-ai-chat__typing';
    typing.textContent = '回答を生成中…';
    messagesEl.appendChild(typing);
    messagesEl.scrollTop = messagesEl.scrollHeight;

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message, history: history.slice(-6) }),
        signal: controller.signal,
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      typing.remove();

      const reply = data.message || FALLBACK_MESSAGE;
      appendBubble(reply, 'assistant');
      history.push({ role: 'assistant', content: reply });
      appendProducts(data.products);
      appendArticles(data.articles);
    } catch {
      typing.remove();
      appendError(FALLBACK_MESSAGE);
    } finally {
      clearTimeout(timeoutId);
      setLoading(false);
    }
  }

  toggleBtn.addEventListener('click', () => setPanelOpen(!isOpen));
  closeBtn.addEventListener('click', () => setPanelOpen(false));

  if (expandBtn) {
    expandBtn.addEventListener('click', () => {
      // 手動リサイズ中のインラインサイズが残っていると拡大切り替えと競合するためクリアする
      panel.style.width = '';
      panel.style.height = '';
      panel.style.maxHeight = '';
      const expanded = panel.classList.toggle('tc-ai-chat__panel--expanded');
      expandBtn.setAttribute('aria-pressed', String(expanded));
      expandBtn.setAttribute(
        'aria-label',
        expanded ? 'チャットウィンドウを元のサイズに戻す' : 'チャットウィンドウを大きく表示'
      );
    });
  }

  // 左上ハンドルからのドラッグ／キーボードリサイズ（PCのみ）。
  // パネルは画面右下（トグルボタン）基準で右・下が固定されているため、
  // 左上を掴んで左・上へ広げると右下を固定したまま自然に拡大できる。
  if (resizeHandle) {
    const MIN_WIDTH = 320;
    const MIN_HEIGHT = 360;
    const RESIZE_STEP = 20;
    const desktopQuery = window.matchMedia('(min-width: 769px) and (pointer: fine)');
    let dragState = null;

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const getMaxWidth = () => Math.min(720, window.innerWidth - 24);
    // 高さの上限は画面全体の75%まで（ユーザー指摘）
    const getMaxHeight = () => window.innerHeight * 0.75;

    function applySize(width, height) {
      panel.style.width = `${width}px`;
      panel.style.height = `${height}px`;
      panel.style.maxHeight = `${height}px`;
    }

    resizeHandle.addEventListener('pointerdown', (event) => {
      if (!desktopQuery.matches) return;
      event.preventDefault();
      const rect = panel.getBoundingClientRect();
      dragState = {
        startX: event.clientX,
        startY: event.clientY,
        startWidth: rect.width,
        startHeight: rect.height,
      };
      panel.classList.add('tc-ai-chat__panel--resizing');
      resizeHandle.setPointerCapture(event.pointerId);
    });

    resizeHandle.addEventListener('pointermove', (event) => {
      if (!dragState) return;
      const width = clamp(
        dragState.startWidth + (dragState.startX - event.clientX),
        MIN_WIDTH,
        getMaxWidth()
      );
      const height = clamp(
        dragState.startHeight + (dragState.startY - event.clientY),
        MIN_HEIGHT,
        getMaxHeight()
      );
      applySize(width, height);
    });

    function endDrag(event) {
      if (!dragState) return;
      if (event && resizeHandle.hasPointerCapture(event.pointerId)) {
        resizeHandle.releasePointerCapture(event.pointerId);
      }
      dragState = null;
      panel.classList.remove('tc-ai-chat__panel--resizing');
    }

    resizeHandle.addEventListener('pointerup', endDrag);
    resizeHandle.addEventListener('pointercancel', endDrag);

    resizeHandle.addEventListener('keydown', (event) => {
      if (!desktopQuery.matches) return;
      const rect = panel.getBoundingClientRect();
      let width = rect.width;
      let height = rect.height;
      let handled = true;

      switch (event.key) {
        case 'ArrowLeft':
          width = clamp(width + RESIZE_STEP, MIN_WIDTH, getMaxWidth());
          break;
        case 'ArrowRight':
          width = clamp(width - RESIZE_STEP, MIN_WIDTH, getMaxWidth());
          break;
        case 'ArrowUp':
          height = clamp(height + RESIZE_STEP, MIN_HEIGHT, getMaxHeight());
          break;
        case 'ArrowDown':
          height = clamp(height - RESIZE_STEP, MIN_HEIGHT, getMaxHeight());
          break;
        default:
          handled = false;
      }

      if (handled) {
        event.preventDefault();
        applySize(width, height);
      }
    });
  }

  panel.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      setPanelOpen(false);
    }
  });

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (isLoading) return;

    const message = input.value.trim();
    if (!message) return;

    input.value = '';
    setLoading(true);
    sendMessage(message);
  });

  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      form.requestSubmit();
    }
  });

  appendBubble(
    'こんにちは。お探しの商品ジャンル・予算・キーワードを教えてください。',
    'assistant'
  );
})();
